import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ONBOARDING_PATH = '/onboarding/poll'
const CACHE_KEY = 'poll_onboarding_done'

interface PollGuardProps {
  children: React.ReactNode
}

export const PollGuard: React.FC<PollGuardProps> = ({ children }) => {
  const location = useLocation()
  const needsPoll = useSelector((state: any) => Boolean(state?.session?.sessionData?.needsPoll))

  if (needsPoll && location.pathname !== ONBOARDING_PATH) {
    return <Navigate to={ONBOARDING_PATH} replace />
  }

  return <>{children}</>
}

export function clearPollGuardCache() {
  sessionStorage.removeItem(CACHE_KEY)
}
